var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluentVehicleCarProfile20Regular3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.756 9.32192C17.756 11.2946 16.1568 12.8938 14.184 12.8938C12.2113 12.8938 10.6121 11.2946 10.6121 9.32192C10.6121 7.3492 12.2113 5.75 14.184 5.75C16.1568 5.75 17.756 7.3492 17.756 9.32192Z",
    stroke: "#363C40",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 27.6901V30.4717C5 31.024 5.44772 31.4717 6 31.4717H21.2877C21.84 31.4717 22.2877 31.024 22.2877 30.4717V22.345C22.2877 19.0313 19.6014 16.345 16.2877 16.345H11C7.68629 16.345 5 19.0313 5 22.345V27.6901ZM5 27.6901H14.7243",
    stroke: "#363C40",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 27C8.25 27.4142 8.58579 27.75 9 27.75C9.41421 27.75 9.75 27.4142 9.75 27L8.25 27ZM8.25 17L8.25 27L9.75 27L9.75 17L8.25 17Z",
    fill: "#363C40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3219 27.1498L17.9657 16.8853",
    stroke: "#363C40",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9316 20.667C28.5427 20.8167 27.2527 20.3203 24.989 19.0463C22.8645 20.4868 21.57 20.8607 19.0463 20.667C19.2606 26.4215 20.5244 28.6904 24.989 31.4718C29.5464 28.8684 31.3918 26.8984 30.9316 20.667Z",
    fill: "white",
    stroke: "#363C40",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3682 24.4485L23.8225 25.8115C23.8687 25.9502 24.0237 26.0198 24.1581 25.9622L27.6901 24.4485",
    stroke: "#363C40",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentVehicleCarProfile20Regular3);
export default __webpack_public_path__ + "static/media/fluent_vehicle-car-profile-20-regular-3.66abbf20a7dea2e28c521d5a48450be4.svg";
export { ForwardRef as ReactComponent };